var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation2 = function SvgLocation2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "location2_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#location2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10c.458 0 .85-.164 1.177-.49.327-.327.49-.719.49-1.177 0-.459-.163-.851-.49-1.177A1.605 1.605 0 0 0 10 6.666c-.458 0-.85.163-1.177.49-.326.326-.49.718-.49 1.177 0 .458.164.85.49 1.177.326.326.719.49 1.177.49Zm0 6.124c1.694-1.555 2.951-2.968 3.77-4.24C14.59 10.615 15 9.486 15 8.5c0-1.514-.483-2.753-1.448-3.718-.965-.966-2.15-1.448-3.552-1.448-1.403 0-2.587.482-3.552 1.448C5.483 5.746 5 6.985 5 8.499c0 .986.41 2.115 1.23 3.386.819 1.27 2.076 2.684 3.77 4.24Zm0 2.209c-2.236-1.903-3.906-3.67-5.01-5.302-1.105-1.632-1.657-3.143-1.657-4.532 0-2.083.67-3.743 2.01-4.979C6.685 2.284 8.237 1.666 10 1.666c1.764 0 3.316.618 4.656 1.854 1.34 1.236 2.01 2.896 2.01 4.98 0 1.388-.551 2.899-1.656 4.53-1.104 1.633-2.774 3.4-5.01 5.303Z",
    fill: "#40424C"
  }))));
};
export default SvgLocation2;